<template>
    <div class="svgPlot-div">
        <div class="search-top">
            <el-input size="small" placeholder="快速搜索" v-model="filterText"> </el-input>
        </div>
        <div class="tree-content">
            <el-tree :default-expanded-keys="defaultExpandedCids" @node-click="nodeClick" :filter-node-method="filterNode"
                :data="treeData" node-key="title" ref="tree" highlight-current :props="defaultProps">
            </el-tree>
        </div>

        <div v-show="pics.length > 0" class="wrapper">
            <div v-for="(item, index) in pics" class="item">
                <el-tooltip>
                    <div slot="content">名称：{{ item.title }}<br />编码：{{ item.code }}</div>
                    <el-image @click="drawImg(item)" :src="NG_Server+'/gisData/svg/' + item.icon"
                        :fit="fit"></el-image>
                        
                    <!-- <el-image @click="drawImg(item)" :src="item.svg" :fit="fit"></el-image> -->

                </el-tooltip>
            </div>
        </div>
    </div>
</template>
<script>
let rotationEnity = null;
let dragToolUit = null;
let graphicEnity = null;
import svgEdit from "./svgEdit.vue";
import DrawRectangle3 from "./lib/rectangle/DrawRectangle"
var drawSvgTool = undefined;
import tree from "./tree.json"
//import treeData from ".data/treeData地面作战行.json"
import treeData from "./treeData.json"
let plotItem;
let plotUti;
export default {
    props:["subData"],
    data() {
        return {
            NG_Server:NG_Server,
            fit: "fill",
            pics: [],
            filterText: "",
            treeData: tree,
            defaultExpandedCids: ["军队标号"],
            defaultProps: {
                children: "children",
                label: "title",
            },
        };
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
    },
    created() {
    },
    mounted() {
        plotUti = DBmap.plotUti;
        if(this.subData=="isPlanEditor"){
            plotUti.bindPlotFlag(true);
        }
        else{
            plotUti.bindPlotFlag(false);
        }
    },
    beforeDestroy() {
       
    },
    methods: {
        callbackEdit(plot) {
            var that = this;
            plot.plotItem = plotItem;
            var dialog = that.$dialog.getDialog("军队标绘");
            if (dialog) {
                that.$dialog.close(dialog);
            }
            that.$dialog.open({
                id: "军队标绘",
                title: "属性编辑",
                area: {
                    height: "800px",
                    width: "300px",
                },
                content: {
                    type: "vue",
                    subCom: svgEdit,
                    subData: () => {
                        return plot;
                    },
                },
            });
        },
        getPickEnity(pick) {
            if (Cesium.defined(pick) && (pick.id)) {
                return pick.id;
            }

            return null;
        },
        dbclick(evt) {
            var ins = this.$dialog.getDialog("矢量标绘");
            if (ins) {
                return;
            }
            let pick = viewer.scene.pick(evt.position);
            var entity = this.getPickEnity(pick);
            // entity.extTag = "BH_Feature";
            if (entity && entity.extTag && entity.extTag == "BH_Feature") {
                this.$confirm("是否删除该矢量标绘？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {

                        if (entity.attrPlot && entity.attrPlot["edit_keyPos"]) {
                            let entities = entity.attrPlot["edit_keyPos"];
                            for (let i = 0; i < entities.length; i++) {
                                viewer.entities.remove(entities[i]);
                            }
                        }

                        if (entity.attrPlot && entity.attrPlot["edit_center"]) {
                            let entities = [entity.attrPlot["edit_center"]];
                            for (let i = 0; i < entities.length; i++) {
                                viewer.entities.remove(entities[i]);
                            }
                        }

                        if (entity.attrPlot && entity.attrPlot["edit_rotation"]) {
                            let entities = [entity.attrPlot["edit_rotation"]];
                            for (let i = 0; i < entities.length; i++) {
                                viewer.entities.remove(entities[i]);
                            }
                        }

                        if (entity.attrPlot && entity.attrPlot["edit_height"]) {
                            let entities = [entity.attrPlot["edit_height"]];
                            for (let i = 0; i < entities.length; i++) {
                                viewer.entities.remove(entities[i]);
                            }
                        }

                        viewer.entities.remove(entity); //自身

                    })
                    .catch(() => {
                        this.$message({
                            showClose: true,
                            type: "info",
                            message: "本次操作已取消！",
                            duration: 3 * 1000,
                        });
                    });

            }
        },
        drawImg(item) {
            
            var img = NG_Server+'/gisData/svg/' + item.icon;
            plotUti.start("military", {
                material: img
            });
            // plotItem = item;
            // //var img = require(`../../components/SvgPlot/icons/${item.path}`);// item.url;
            // var img = item.svg;// 'http://localhost:8999/gisData/' + item.svg;//
            // if (!drawSvgTool) {
            //     drawSvgTool = new DrawRectangle3({ canEdit: true });
            //     drawSvgTool.callbackEdit = this.callbackEdit
            // }

            // drawSvgTool.reset();
            // drawSvgTool.start({
            //     style: {
            //         material: img,
            //     },
            // }
            // );

            if(this.subData=="isPlanEditor"){
                this.$parent.close();
            }
        },
        nodeClick(item, node, el) {

            this.pics = [];
            //叶子节点
            if (!item.children || item.children.length < 1) {


                //this.pics=treeData.children;
                

                //40205.svg
                //40204.svg
                // this.pics = [

                //     // {
                //     //     svg: "svg/双色.svg"
                //     // },
                //     // {
                //     //     svg: "svg/01.svg"
                //     // },
                //     // {
                //     //     svg: "svg/02.svg"
                //     // },
                //     // {
                //     //     svg: "svg/03.svg"
                //     // },
                //     // {
                //     //     svg: "svg/04.svg"
                //     // },
                //     // {
                //     //     svg: "svg/05.svg"
                //     // },
                //     // {
                //     //     svg: "svg/06.svg"
                //     // },
                //     {
                //         svg: "svg/图标-01.svg"
                //     },
                //     {
                //         svg: "svg/图标-02.svg"
                //     },
                //     {
                //         svg: "svg/图标-03.svg"
                //     },
                //     {
                //         svg: "svg/图标-04.svg"
                //     },
                //     {
                //         svg: "svg/图标-05.svg"
                //     },
                //     {
                //         svg: "svg/图标-06.svg"
                //     },
                //     {
                //         svg: "svg/图标-07.svg"
                //     },
                //     {
                //         svg: "svg/图标-08.svg"
                //     },
                //     {
                //         svg: "svg/图标-09.svg"
                //     },
                //     {
                //         svg: "svg/图标-10.svg"
                //     },
                //     {
                //         svg: "svg/图标-11.svg"
                //     },
                //     {
                //         svg: "svg/图标-12.svg"
                //     },
                //     {
                //         svg: "svg/图标-13.svg"
                //     },
                //     {
                //         svg: "svg/图标-14.svg"
                //     },
                //     {
                //         svg: "svg/图标-15.svg"
                //     },
                //     {
                //         svg: "svg/图标-16.svg"
                //     },
                //     {
                //         svg: "svg/图标-17.svg"
                //     },
                //     {
                //         svg: "svg/图标-18.svg"
                //     },
                //     {
                //         svg: "svg/图标-19.svg"
                //     },
                //     {
                //         svg: "svg/图标-20.svg"
                //     },
                //     {
                //         svg: "svg/图标-21.svg"
                //     },
                //     {
                //         svg: "svg/图标-22.svg"
                //     },
                //     {
                //         svg: "svg/图标-23.svg"
                //     },
                //     {
                //         svg: "svg/图标-24.svg"
                //     },
                //     {
                //         svg: "svg/图标-25.svg"
                //     },
                //     {
                //         svg: "svg/图标-26.svg"
                //     },
                // ];
                var file = this.getItemByName(treeData, item.title);
                if (file) {
                    this.pics = file.children;
                }
            }
        },
        getItemByName(list, name) {
            if (!list) {
                return;
            }
            var item;
            for (var i = 0; i < list.length; i++) {
                var element = list[i];
                if (element.title == name) {
                    item = element;
                    return item;
                }
                item = this.getItemByName(element.children, name);
                if (item) {
                    return item;
                }
            }
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.title.indexOf(value) !== -1;
        },
    },
};
</script>
  
<style lang="scss" scoped>
.search-top {
    margin-bottom: 10px;
}

.tree-content {
    max-height: 30vh;
    overflow: auto;
    // border: solid 1px #e4e7ed;
}

.wrapper {
    margin-top: 20px;
    padding: 16px 16px 16px 16px;
    display: grid;
    grid-gap: 16px;
    // border: solid 1px #e4e7ed;
    border-top: 1px solid rgba(#fff, 0.2);
    max-height: 20vh;
    ;
    overflow-y: auto;
    overflow-x: hidden;
    grid-template: repeat(4, 1fr) / repeat(4, 1fr);
}

.item {
    text-align: center;
    border: 1px solid rgba(#fff, 0.5);
    width: auto;
    padding: 2px 4px;

    .el-image {
        height: 40px;
    }
}
</style>
  
<style lang="scss">
.svgPlot-div {
    .el-input__inner {
        background-color: transparent !important;
        border: 1px solid rgba(#fff, 0.2);
        color: #ffffff;
    }

    .el-tree__empty-text {
        color: #ffffff;
    }

    .el-tree {
        background: none;
        color: #ffffff;
    }

    .el-tree-node__content:hover,
    .el-upload-list__item:hover {
        background-color: transparent !important;
        color: #83E9FF;
    }

    .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
        background-color: transparent !important;
        color: #83E9FF;
    }

    .el-tree-node:focus>.el-tree-node__content {
        background-color: transparent !important;
    }
}
</style>
  